import { useCallback, useEffect, useRef, useState } from 'react';
import financeApi from '../../../services/financeApi';

// Does this company have anything from before Stripe?
//
// Asked so Payouts can decide whether to offer the way back to it at all. A
// restaurant onboarded straight onto Connect has no "before", and a button
// promising records that never existed sends it hunting for them.
//
// One row is the whole question, so the read asks for one row. The page
// behind the button does its own paged read — this is a yes/no, not a
// prefetch, and treating it as one would mean fetching a page the reader may
// never open.
const useLegacyFinance = (companyId) => {
  const [hasHistory, setHasHistory] = useState(false);
  const requestId = useRef(0);
  const mounted = useRef(true);
  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; };
  }, []);

  const check = useCallback(async () => {
    if (!companyId) return;
    requestId.current += 1;
    const id = requestId.current;
    try {
      const res = await financeApi.list(`?companyid=${companyId}&pageNumber=1&pageSize=1`);
      if (!mounted.current || id !== requestId.current) return;
      setHasHistory((res?.data?.totalRecords || 0) > 0);
    } catch {
      // Fail closed. A read that failed is not proof there is history, and
      // offering a button on a guess would land the reader on an empty page
      // with no explanation for why it is empty.
      if (mounted.current && id === requestId.current) setHasHistory(false);
    }
  }, [companyId]);

  useEffect(() => {
    check();
  }, [check]);

  return hasHistory;
};

export default useLegacyFinance;
